import { React, useEffect, useState } from "react";

import { RootLayout } from "../../layout";
import DetalhesDadosClinicos from "../../pages/HomePaciente/modulos/DetalhesDadosClinicos";
import { formatDateISO8601, formatDateMethod3 } from "../../utils/formatarData";
import { calcularDiferencaEmAnos } from "../../utils/diferencaEntreDatas";
import { diferencaDatasEmMeses } from "../../utils/diferencaEntreDatasMeses";
import { calculaTempoDataCirurgia } from "../../utils/calculaTempoDataCirurgia";
import api from "../../services/api";
import CardPaciente from "../../components/CardPaciente";
import { Content1, NoteIcon, CardNotification } from "./CardHome";
import iconsetting from "../../images/iconSettings.svg";

import "./styles.css";
import {
  Box,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Stack,
  Divider,
  Chip,
} from "@mui/material";
import { getItemDecrypt } from "../../utils/cryptoData";
import dayjs from "dayjs";
import ModalDialogs from "../../components/ModalDialogs";
import { FieldInputText } from "../../components/Fields";

const consultTypes = [
  {
    id: 1,
    label: "Presencial",
  },
  {
    id: 2,
    label: "Teleconsulta",
  },
  {
    id: 3,
    label: "Híbrida",
  },
];

export default function HomePaciente() {
  const [dadosClinicos, setDadosClinicos] = useState({});
  const [atrasoDiagnostico, setAtrasoDiagnostico] = useState(0);
  const [idadeInicioDoenca, setIdadeInicioDoenca] = useState(0);
  const [cirurgias, setCirurgias] = useState([]);
  const [tempoCirurgias, setTempoCirurgias] = useState([]);
  const [dadosDiagnosticoELA, setDadosDiagnosticoELA] = useState({});
  const [appointments, setAppointments] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [appointmentSelected, setAppointmentSelected] = useState(null);
  const [internalHealthTeam, setInternalHealthTeam] = useState([]);
  const [externalHealthTeam, setExternalHealthTeam] = useState([]);

  const pacienteId = getItemDecrypt("paciente");
  const user = getItemDecrypt("usuario");

  useEffect(() => {
    getDadosPaciente();
  }, []);

  const respostaByPerguntaId = (pergunta_id) => {
    if (dadosClinicos.length > 0) {
      let elementoEncontrado = dadosClinicos.find(function (objeto) {
        return objeto.idPergunta === pergunta_id;
      });

      if (elementoEncontrado) {
        return elementoEncontrado?.resposta;
      } else {
        if (dadosDiagnosticoELA.length > 0) {
          elementoEncontrado = dadosDiagnosticoELA.find(function (objeto) {
            return objeto.idPergunta === pergunta_id;
          });

          return elementoEncontrado?.resposta;
        }
      }
    }
  };

  async function getDadosPaciente() {
    try {
      const { data } = await api.get(`/detalhes-dados-clinicos/${pacienteId}`);
      const dadosDiagnosticoELA = await api.get(
        `/dados-diagnostico-ela/${pacienteId}`
      );
      const appoint = await api.get(`/agenda-paciente/${user.co_id}`);
      setAppointments(appoint.data);
      setDadosClinicos(data);
      setDadosDiagnosticoELA(dadosDiagnosticoELA.data);
      trataCirurgiasDatas(data);
      const response = [...data, ...dadosDiagnosticoELA.data];
      calculaAtrasoDiagnostico(response);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function calculaIdadeInicioSintomas(dataDiagnostico) {
    const { data } = await api.get(`/dadospaciente/${pacienteId}`);

    if (dataDiagnostico) {
      const dataNascimento = formatDateISO8601(data.dataNascimento);
      const dataDiagnosticoFormatada = formatDateMethod3(dataDiagnostico);

      const idadeDeInicioDaDoenca = calcularDiferencaEmAnos(
        dataNascimento,
        dataDiagnosticoFormatada
      );

      setIdadeInicioDoenca(idadeDeInicioDaDoenca);
    }
  }

  const calculaAtrasoDiagnostico = (data) => {
    if (dadosClinicos) {
      var dataDiagnostico = data.find(function (objeto) {
        return objeto.idPergunta === 205;
      })?.resposta;

      var dataPrimeiroSintoma = data.find(function (objeto) {
        return objeto.idPergunta === 6;
      }).resposta;

      if (dataDiagnostico && dataPrimeiroSintoma) {
        setAtrasoDiagnostico(
          diferencaDatasEmMeses(dataPrimeiroSintoma, dataDiagnostico)
        );
      } else {
        setAtrasoDiagnostico("-");
      }

      calculaIdadeInicioSintomas(dataDiagnostico);
    }
  };

  const trataCirurgiasDatas = (data) => {
    let elementoEncontrado = data.find(function (objeto) {
      return objeto.idPergunta === 18;
    });

    elementoEncontrado?.resposta.forEach((item) => {
      const nomeCirurgia = item.split("-")[0];
      const data = item.split("-")[1];

      cirurgias.push(nomeCirurgia);
      setCirurgias(cirurgias);

      tempoCirurgias.push(calculaTempoDataCirurgia(data));
      setTempoCirurgias(tempoCirurgias);
    });
  };

  // const delayedScheduling = useCallback((day, time) => {
  //   const currentDay = dayjs();
  //   const scheduling = dayjs(day)
  //     .set("hour", parseInt(time.split(":")[0], 10))
  //     .set("minute", parseInt(time.split(":")[1], 10))
  //     .set("second", 0)
  //     .set("millisecond", 0);

  //   return currentDay.isAfter(scheduling);
  // }, []);

  const handleModalOpen = (appointment) => {
    var data = appointment.dataConsulta.split("T");
    data = `${data[0]}T${appointment.inicio}:00`;

    const internalHealthTeamData = appointment.participantes.filter(
      (pf) => pf.estabelecimento.id === appointment.estabelecimento.id
    );

    const externalHealthTeamData = appointment.participantes.filter(
      (pf) => pf.estabelecimento.id !== appointment.estabelecimento.id
    );

    setInternalHealthTeam(internalHealthTeamData);
    setExternalHealthTeam(externalHealthTeamData);
    setAppointmentSelected({
      ...appointment,
      dataConsulta: dayjs(data),
    });
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <RootLayout>
        <CardPaciente id={pacienteId} />
        <DetalhesDadosClinicos
          respostaByPerguntaId={respostaByPerguntaId}
          idadeInicioDoenca={idadeInicioDoenca}
          atrasoDiagnostico={atrasoDiagnostico}
          cirurgias={cirurgias}
          tempoCirurgias={tempoCirurgias}
        />

        <Accordion defaultExpanded={false} className="AccordionContainer">
          <AccordionSummary
            expandIcon={<img src={iconsetting} alt="Icon" />}
            aria-controls="notifications-content"
            id="notifications-header"
            className="AccordionSummaryContainer"
          >
            <div className="detalhes-clinicos">
              <Typography className="Accordion_title">
                {appointments.length > 1 ? "Notificações" : "Notificação"} (
                {appointments.length > 0 ? appointments.length : "0"})
              </Typography>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <Divider
              sx={{
                background: "#3F94C2",
              }}
            />
            <Grid
              container
              gap={"24px 16px"}
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
                boxSizing: "border-box !important",
                padding: "24px 0px",
                textAlign: "left",
              }}
              width="100%"
            >
              {appointments.map((item, index) => (
                <Grid item height={"100%"}>
                  <CardNotification
                    title={`Próximo Consulta`}
                    icon={<NoteIcon />}
                    color={"#cccc"}
                    onClick={() => handleModalOpen(item)}
                  >
                    <Content1 data={item} />
                  </CardNotification>
                </Grid>
              ))}

              <Grid item></Grid>
              <Grid item></Grid>

              {/* <Grid height={"100%"}>
                <CardNotification
                  title={"Acompanhamento"}
                  icon={<DocumentIcon />}
                >
                  <Stack
                    color="#063F5E"
                    flexDirection="row"
                    gap={2}
                    alignItems="center"
                    justifyContent="center"
                    height="100%"
                  >
                    <Stack width={24} height={24}>
                      <NoteIcon />
                    </Stack>{" "}
                    <Typography>
                      A <strong>escala funcional</strong> está disponível para{" "}
                      <strong>prenchimento</strong>{" "}
                    </Typography>
                  </Stack>
                </CardNotification>
              </Grid>
              <Grid height={"100%"}>
                <CardNotification title={"Próximo exame"} icon={<VacinaIcon />}>
                  <Content1 />
                </CardNotification>
              </Grid> */}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </RootLayout>
      <ModalDialogs
        open={openModal}
        onClose={() => handleModalClose()}
        title="Consulta"
        maxWidth="800px"
        primaryButtonText="Fechar"
        onActionPrimary={() => handleModalClose()}
        body={
          appointmentSelected && (
            <Stack sx={{ width: { xs: "100%", md: "800px" } }}>
              <Grid
                container
                gap={"24px 16px"}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  boxSizing: "border-box !important",
                  padding: 3,
                  textAlign: "left",
                }}
                width="100%"
              >
                <Grid item>
                  <Stack spacing={1}>
                    <Typography
                      sx={{
                        fontFamily: "Nunito",
                        fontSize: "16px",
                        fontWeight: 600,
                        lineHeight: "22px",
                        color: "#063f5e",
                      }}
                    >
                      Local de atendimento
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Nunito",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "22px",
                        color: "#737373",
                        textTransform: "capitalize",
                      }}
                    >
                      {appointmentSelected?.estabelecimento &&
                        appointmentSelected.estabelecimento.nome}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item>
                  <Stack spacing={1}>
                    <Typography
                      sx={{
                        fontFamily: "Nunito",
                        fontSize: "16px",
                        fontWeight: 600,
                        lineHeight: "22px",
                        color: "#063f5e",
                      }}
                    >
                      Profissional responsável
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Nunito",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "22px",
                        color: "#737373",
                        textTransform: "capitalize",
                      }}
                    >
                      {appointmentSelected?.vinculo &&
                        appointmentSelected.vinculo.usuario.nome}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item>
                  <FieldInputText
                    label="Paciente"
                    isEditField={false}
                    defaultValue={appointmentSelected?.paciente.nome}
                    value={appointmentSelected?.paciente.nome}
                    disabled
                    setValue={(e, newValue) => {}}
                    required
                  />
                </Grid>
                <Grid item>
                  <FieldInputText
                    label="Tipo da consulta"
                    value={
                      consultTypes.find(
                        (item) => item.id === appointmentSelected?.id_categoria
                      ).label
                    }
                    setValue={(value) => {}}
                    isEditField={false}
                  />
                </Grid>
                <Grid item>
                  <FieldInputText
                    label="Equipe de saúde interna"
                    setValue={(value) => {}}
                    isEditField={false}
                  />
                  <Stack
                    direction="row"
                    flexWrap="wrap"
                    sx={{
                      gap: 0,
                      marginTop: "-38px",
                    }}
                  >
                    {internalHealthTeam.map((v, index) => (
                      <Chip
                        disabled={true}
                        sx={{
                          background: "#ffff",
                          marginLeft: "-11px",
                          opacity: "1 !important",
                          fontSize: "16px",
                          color: "#9e9e9e",
                          "& .MuiChip-deleteIcon": {
                            color: "transparent",
                          },
                        }}
                        key={v.co_id}
                        label={`${v.usuario.nome} - ${v.perfil.descricao}`}
                      />
                    ))}
                  </Stack>
                </Grid>
                <Grid item>
                  <FieldInputText
                    label="Equipe de saúde externa"
                    setValue={(value) => {}}
                    isEditField={false}
                  />
                  <Stack
                    direction="row"
                    flexWrap="wrap"
                    sx={{
                      gap: 0,
                      marginTop: "-38px",
                    }}
                  >
                    {externalHealthTeam.map((v, index) => (
                      <Chip
                        disabled={true}
                        sx={{
                          background: "#ffff",
                          marginLeft: "-11px",
                          opacity: "1 !important",
                          fontSize: "16px",
                          color: "#9e9e9e",
                          "& .MuiChip-deleteIcon": {
                            color: "transparent",
                          },
                        }}
                        key={v.co_id}
                        label={`${v.usuario.nome} - ${v.perfil.descricao}`}
                      />
                    ))}
                  </Stack>
                </Grid>

                <Grid item>
                  <>
                    <Typography fontWeight={600} mb={1}>
                      Data e horário
                    </Typography>
                    <Typography
                      color={"#737373"}
                      sx={{
                        textTransform: "capitalize",
                      }}
                    >
                      {dayjs(appointmentSelected.dataConsulta)
                        .locale("pt-br")
                        .format("dddd, D [de] MMMM [de] YYYY")}
                    </Typography>
                    <Typography color={"#737373"}>
                      {dayjs(appointmentSelected.dataConsulta)
                        .locale("pt-br")
                        .format("HH[h]mm")}{" "}
                      ás{" "}
                      {dayjs(appointmentSelected.dataConsulta)
                        .add(30, "minute") // Adiciona 30 minutos
                        .locale("pt-br")
                        .format("HH[h]mm")}{" "}
                    </Typography>
                  </>
                </Grid>
              </Grid>
              <Divider />
            </Stack>
          )
        }
      />
    </Box>
  );
}
